import {MouseEventHandler} from 'react';
import {t} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {twMerge} from '../../../common/twMerge';
import {TicketKind} from '../../../graphql/generated/types';
import {Text} from '../../atoms/Text/Text';
import {Control} from '../../molecules/Control/Control';

interface DialogTicketCountControlProps {
  title?: string;
  ticketKind?: TicketKind;
  totalTicketCount?: number;
  isBuyAtOnce?: boolean;
  quantity?: number;
  onClickMinus?: MouseEventHandler;
  onClickPlus?: MouseEventHandler;
}

export function DialogTicketCountControl({
  title,
  ticketKind,
  totalTicketCount,
  isBuyAtOnce,
  quantity,
  onClickMinus,
  onClickPlus,
}: DialogTicketCountControlProps) {
  return (
    <div className="flex items-center justify-between space-x-40pxr">
      <div className="flex flex-col py-4pxr">
        <Text className="font-medium1-bold break-all text-theme-solid-100 line-clamp-2">
          {title}
        </Text>
        <Text
          className={twMerge(
            'font-medium1-bold mt-2pxr text-static-point-green',
            ticketKind === TicketKind.Own && 'text-static-point-blue'
          )}
        >
          {isBuyAtOnce && <>{t('ticket_purchase_purchase_all')}</>}
          {!isBuyAtOnce && (
            <>
              {totalTicketCount
                ? ticketKind === TicketKind.Rent
                  ? t('common_ticket_rental_amount', {
                      values: {value: formatWithCommas(totalTicketCount)},
                    })
                  : t('common_ticket_possession_amount', {
                      values: {value: formatWithCommas(totalTicketCount)},
                    })
                : ticketKind === TicketKind.Rent
                  ? t('common_ticket_rental')
                  : t('common_ticket_possession')}
            </>
          )}
        </Text>
      </div>
      {!isBuyAtOnce && quantity && onClickMinus && onClickPlus && (
        <Control
          className="min-w-fit"
          isMinusDisabled={quantity <= 1}
          count={quantity}
          onClickMinus={onClickMinus}
          onClickPlus={onClickPlus}
        />
      )}
    </div>
  );
}

export const DialogTicketCountControlType = (<DialogTicketCountControl />).type;
